<template>
    <div class="col-xs-12 filters-top">
        <form id="filter-weight-measurement-form">
            <div class="input-group flex date datetimepicker">
                <label>Från</label>
                <input
                    type="text"
                    name="fran"
                    id="from-date-filter"
                    v-model="fromDate"
                    class="form-control"
                />
                <span class="input-group-addon">
                    <span class="glyphicon glyphicon-calendar"></span>
                </span>
            </div>

            <div class="input-group flex date datetimepicker">
                <label>Till</label>
                <input type="text" name="till" id="to-date-filter" v-model="toDate" class="form-control" />
                <span class="input-group-addon">
                    <span class="glyphicon glyphicon-calendar"></span>
                </span>
            </div>

            <button type="submit" class="btn btn-success flex">Filtrera</button>

            <button v-if="showDeleteAll" class="measurement-delete-all btn btn-primary">Radera alla</button>

            <a v-if="!showButton" class="reset" href="/min-sida/vikt-matt">Återställ</a>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fromDate: this.toSwedishString(new Date().toJSON()),
            toDate: this.toSwedishString(new Date().toJSON()),
            queryDict: {},
            showButton: false
        };
    },

    props: {
        userLength: Number,
        measurements: Array,
        signupDate: String
    },

    computed: {
        showDeleteAll: function () {
            if (window.location.href.indexOf('fran=') > -1 && window.location.href.indexOf('till=') > -1) {
                return false;
            }

            if (this.measurements.length < 1) {
                return false;
            }

            return true;
        },

        signUp: function () {
            return Date.parse(this.signupDate);
        },

        threeMonthsAgo: function () {
            return new Date().setMonth(new Date().getMonth() - 3);
        }
    },

    mounted() {
        const now = new Date();

        this.fromDate =
            this.signUp >= this.threeMonthsAgo
                ? this.toSwedishString(this.signUp)
                : this.toSwedishString(this.threeMonthsAgo);

        // if(this.measurements.length) {

        //     // const allowedDates = this.measurements.filter( m => Date.parse( m.Datum) >= Date.parse(this.fromDate) ).map( m => m.Datum );

        //     // this.toDate = allowedDates.length > 0 ? allowedDates[0] : this.toSwedishString(now.toJSON())

        //     this.toDate = this.toSwedishString(now.toJSON())

        // }

        if (location.search.substr(1).length) {
            location.search
                .substr(1)
                .split('&')
                .forEach((item) => {
                    this.queryDict[item.split('=')[0]] = item.split('=')[1];
                });
        }

        if (this.queryDict.fran) {
            this.fromDate = this.queryDict.fran;
        }

        if (this.queryDict.till) {
            this.toDate = this.queryDict.till;
        }

        this.showButton = Object.keys(this.queryDict).length === 0 ? true : false;
    },

    methods: {
        toSwedishString: function (date) {
            return new Date(date).toISOString('sv-SE').slice(0, 10);
        }
    }
};
</script>
